import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase environment variables REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY are missing. Please verify your environment configuration.'
  );
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');
